import { useGetForgotPassword } from '@r/api/generated/client.ts';
import { useQuery } from '@tanstack/react-query';
import { UpdatePasswordForm } from '@r/components/resetPassword/update-password-form.tsx';
import { Button } from '@ui/button.tsx';
import { CheckCircle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@ui/card.tsx';
import { useTranslation } from 'react-i18next';
import { Link, useParams, notFound } from '@tanstack/react-router';
import { Loader } from '@r/components/loader/loader.tsx';

const ResetPasswordCallback = () => {
  const { t } = useTranslation();

  const { token }: { token: string } = useParams({ strict: false });

  const updatePasswordQuery = useQuery({
    queryKey: ['update_password'],
    staleTime: 0,
    enabled: false
  });

  const resetPasswordCallbackQuery = useGetForgotPassword(token);

  if (resetPasswordCallbackQuery.isLoading) {
    return <Loader />;
  }

  if (resetPasswordCallbackQuery.isError) {
    throw notFound();
  }

  if (resetPasswordCallbackQuery.isSuccess) {
    if (updatePasswordQuery.data) {
      return (
        <div className="container flex flex-col pt-8 grow">
          <div className="flex max-w-[100%] flex-grow items-center sm:w-[32rem]">
            <Card className="w-[32rem] rounded-[30px] p-16">
              <CardHeader className="p-0">
                <div className="flex justify-center text">
                  <CheckCircle className="w-16 h-auto stroke-accent" />
                </div>

                <CardTitle className="text-2xl text-center font-author-complete font-regular text-foreground">
                  {t('forgot.password.reset.confirmation')}
                </CardTitle>
              </CardHeader>

              <CardContent className="p-0 mt-12">
                <Link to="/">
                  <Button className="w-full">{t('reset.password.email.btn.home')}</Button>
                </Link>
              </CardContent>
            </Card>
          </div>
        </div>
      );
    }
    return (
      <div className="container flex flex-col pt-8 grow">
        <div className="flex max-w-[100%] flex-grow items-center sm:w-[32rem]">
          <Card className="w-[32rem] rounded-[30px] p-16">
            <CardHeader className="p-0 text-center">
              <CardTitle className="text-2xl text-center font-author-complete font-regular text-foreground">
                {t('forgot.password.reset.title')}
              </CardTitle>

              <CardDescription className="text-sm font-light text-center text-muted-foreground">
                {t('forgot.password.reset.description')}
              </CardDescription>
            </CardHeader>

            <CardContent className="p-0 mt-12">
              <UpdatePasswordForm tokenValue={token} />
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }
};

export default ResetPasswordCallback;
